import React, {Component} from 'react';
import './index.module.scss';
import Modal from 'react-responsive-modal';



class ModalContainer extends Component {

    constructor() {
        super();

        this.state = {
            width: 0,
            height: 0
        };

        this.closeModal = this.closeModal.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    closeModal() {
        this.props.closeModal();
    }

    render() {
        return(
            <Modal styleName='modal'
                styles={{
                    overlay: {
                        // overflow: 'hidden'
                    },
                    modal: {
                        padding:0,
                        width: (this.state.width < 1024) ? '90vw' : '60vw',
                        maxWidth: this.props.maxWidth ? this.props.maxWidth : 1024
                    },
                    closeButton: {
                        height: 60,
                        width: 60,
                        backgroundColor: '#fff',
                        position: 'absolute',
                        right: 0,
                        top:0,
                        cursor: 'pointer',
                    },
                    closeIcon: {
                        width:'100%',
                    }
                }}
                open={this.props.open}
                onClose={this.closeModal}
                closeIconSize={23}
                animationDuration={200}>
                    
                {this.props.children}
            </Modal>
        );
    }
}


export default ModalContainer;



// WEBPACK FOOTER //
// ./resources/assets/components/UI/ModalContainer/index.jsx